import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import { DateGroupStyled } from './styled';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import moment from 'moment';
import { Inputs } from 'components';

const buildQuarterValue = (q) =>
  `start_date=${moment()
    .quarter(q)
    .startOf('quarter')
    .format('YYYY-MM-DD')}&end_date=${moment()
    .quarter(q)
    .endOf('quarter')
    .format('YYYY-MM-DD')}&types=quarter`;

const QUARTER_OPTIONS = [
  { label: 'ไตรมาส1', value: buildQuarterValue(1) },
  { label: 'ไตรมาส2', value: buildQuarterValue(2) },
  { label: 'ไตรมาส3', value: buildQuarterValue(3) },
  { label: 'ไตรมาส4', value: buildQuarterValue(4) },
];

const DateGroup = ({
  theme_standard,
  initialValues,
  iconSvgClose,
  iconSvgOpen,
  options,
  placeholder,
  onChange,
  onChangeCustom,
  ...props
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  const [_level1Value, _setLevel1Value] = useState();
  const [_renderFilter, _setRenderFilter] = useState();

  const renderSubByLevel1 = (key, seed) => {
    if (key === 'quarter') {
      const quarterValue =
        seed && seed.start_date && seed.end_date
          ? `start_date=${seed.start_date}&end_date=${seed.end_date}&types=quarter`
          : undefined;
      return (
        <Dropdown
          className="dg_input_container"
          controlClassName="input_dropdown_control"
          placeholderClassName="input_dropdown_placeholder"
          menuClassName="input_dropdown_menu"
          options={QUARTER_OPTIONS}
          {...props}
          arrowClosed={
            <span className="arrow_icon arrow-closed">{iconSvgClose}</span>
          }
          arrowOpen={
            <span className="arrow_icon arrow-open">{iconSvgOpen}</span>
          }
          placeholder={placeholder}
          value={quarterValue}
          onChange={(e) => {
            onChange(e.value);
          }}
        />
      );
    }
    if (key === 'date_range') {
      return (
        <Inputs.InputDatePickerBetween
          startDatePlaceholder="เริ่ม"
          endDatePlaceholder={'สิ้นสุด'}
          initialStartDate={seed && seed.start_date}
          initialEndDate={seed && seed.end_date}
          onChange={(e) => {
            onChange(
              `start_date=${moment(e.startDate).format(
                'YYYY-MM-DD'
              )}&end_date=${moment(e.endDate).format('YYYY-MM-DD')}&types=date_range`
            );
          }}
        />
      );
    }
    return false;
  };

  const ivLevel1 = initialValues && initialValues.level1;
  const ivStart = initialValues && initialValues.start_date;
  const ivEnd = initialValues && initialValues.end_date;
  useEffect(() => {
    if (ivLevel1) {
      _setLevel1Value(ivLevel1);
      _setRenderFilter(renderSubByLevel1(ivLevel1, initialValues));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ivLevel1, ivStart, ivEnd]);

  const _onChangeFilterLevel1 = (key) => {
    switch (key) {
      case 'day':
        _setRenderFilter(false);
        onChange(
          `start_date=${moment().format(
            'YYYY-MM-DD'
          )}&end_date=${moment().format('YYYY-MM-DD')}&types=day`
        );
        break;
      case 'month':
        _setRenderFilter(false);
        onChange(
          `start_date=${moment()
            .startOf('month')
            .format('YYYY-MM-DD')}&end_date=${moment()
            .endOf('month')
            .format('YYYY-MM-DD')}&types=month`
        );
        break;
      case 'quarter':
        _setRenderFilter(renderSubByLevel1('quarter'));
        break;
      case 'date_range':
        _setRenderFilter(renderSubByLevel1('date_range'));
        break;
      default:
        break;
    }
  };

  return (
    <DateGroupStyled>
      <div className={customClass}>
        <div className="dddddfdsfdsf">
          <Dropdown
            className="dg_input_container"
            controlClassName="input_dropdown_control"
            placeholderClassName="input_dropdown_placeholder"
            menuClassName="input_dropdown_menu"
            options={options}
            {...props}
            arrowClosed={
              <span className="arrow_icon arrow-closed">{iconSvgClose}</span>
            }
            arrowOpen={
              <span className="arrow_icon arrow-open">{iconSvgOpen}</span>
            }
            placeholder={placeholder}
            value={_level1Value}
            onChange={(e) => {
              _setLevel1Value(e.value);
              _onChangeFilterLevel1(e.value);
            }}
          />
          {_renderFilter}
        </div>
      </div>
    </DateGroupStyled>
  );
};

DateGroup.propTypes = {};

export default DateGroup;
